import { useContextState } from "../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    return {

        mapLink: {
            cursor: 'pointer',
            //color: 'primary.main',
            textDecoration: 'underline',
            '& .MuiSvgIcon-root': {
                fontSize: 'inherit',
                verticalAlign: 'middle',
                display: 'inline-block',
                mr: 0.5,
                color: 'primary.main',
            },
            '&:hover': {
                color: 'primary.dark',
                '& .MuiSvgIcon-root': {
                    color: 'primary.dark',
                },
            },
        },
        flex: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        titles: {
            marginTop: 2,
            paddingBottom: 1,
            borderBottom: `1px solid ${colors.color13}`
        },
        error: {
            alignItems: 'center',
            display: 'flex',
            color: colors.color19,
            gap: '3px',
            '& .MuiSvgIcon-root': {
                fontSize: '1rem'
            },
        },
        destionation: {
            width: '50%',
        }

    }
}

export { useStyles }
